// Editor-curated collections, bundled like the example lists so they work offline. Generated
// from curation/records by curation/scripts/publish.mjs; only human-approved records are in it.
import bundle from "./editorial.json";

export const EDITORIAL: { slug: string; list: unknown }[] = bundle.collections;
